
export class FormatoMensagem {

    public id: string;
    public nome: string;

    constructor(){
        
    }
}
